(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('PhotoDetailController', PhotoDetailController);

    PhotoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Photo', 'PublicProfile'];

    function PhotoDetailController($scope, $rootScope, $stateParams, previousState, entity, Photo, PublicProfile) {
        var vm = this;

        vm.photo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:photoUpdate', function(event, result) {
            vm.photo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
